
define('template!webshopProductsDetailBodyImagesTypeListImageView', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<img src="' +
((__t = ( src )) == null ? '' : __t) +
'">\n  <select class="lang-select" title="' +
((__t = ( _.i18n('webshop.product.images.language', null, 'Image language') )) == null ? '' : __t) +
'">\n    <option value="" ' +
((__t = ( !lang ? 'selected' : '' )) == null ? '' : __t) +
'>' +
((__t = ( _.i18n('webshop.product.images.allLanguages', null, 'All languages') )) == null ? '' : __t) +
'</option>\n    ';
 _.each(languages, function (language) { ;
__p += '\n      <option value="' +
((__t = ( language )) == null ? '' : __t) +
'" ' +
((__t = ( lang === language ? 'selected' : '' )) == null ? '' : __t) +
'>' +
((__t = ( language.toUpperCase() )) == null ? '' : __t) +
'</option>\n    ';
 }); ;
__p += '\n  </select>\n  <div class="buttons-ctn">\n    <div class="buttons">\n      <div class="delete-button" title="' +
((__t = ( _.i18n('common.delete') )) == null ? '' : __t) +
'">\n        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M135.2 17.7L128 32H32C14.3 32 0 46.3 0 64S14.3 96 32 96H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H320l-7.2-14.3C307.4 6.8 296.3 0 284.2 0H163.8c-12.1 0-23.2 6.8-28.6 17.7zM416 128H32L53.2 467c1.6 25.3 22.6 45 47.9 45H346.9c25.3 0 46.3-19.7 47.9-45L416 128z"/></svg>\n      </div>\n      <div class="zoom-button" title="' +
((__t = ( _.i18n('common.zoom') )) == null ? '' : __t) +
'">\n        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"/></svg>\n      </div>\n    </div>\n </div>\n';

}
return __p
};});

